// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc-container[data-v-e3389a52]{background:rgba(40,40,40,.8);color:#fff;border-radius:3px;overflow:auto;-webkit-overflow-scrolling:touch}.desc-container .title[data-v-e3389a52]{font-size:1.1em;text-align:center;padding:5px}.desc-container .text[data-v-e3389a52]{padding:0 20px 20px 20px}", ""]);
// Exports
module.exports = exports;
